import { render } from "./DownloadSigned.vue?vue&type=template&id=53a4ab48&scoped=true"
import script from "./DownloadSigned.vue?vue&type=script&lang=js"
export * from "./DownloadSigned.vue?vue&type=script&lang=js"

import "@/assets/css/views/DownloadSigned.scss?vue&type=style&index=0&id=53a4ab48&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53a4ab48"]])

export default __exports__